import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

Vue.use(VueGtm, {
  id: store.getters['login/setup'].ds_dicomvix_gtm || 'GTM-PKB78C8', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

router.beforeEach((to, from, next) => {
  if (store.getters['login/setup']?.ds_dicomvix_title) {
    document.title = store.getters['login/setup'].ds_dicomvix_title
  }

  if (!to.path.includes('404') && !to.path.includes('otrs') && (Object.keys(to).length === 0 || to.name === undefined)) {
    window.open('/404', '_self')
    return false
  }

  if (to.path.includes('404')) {
    next()
    return false
  }

  if (to.meta.requiresAuth) {
    let urlLogin = to.fullPath.split('/')
    urlLogin = `/${urlLogin[1]}/${urlLogin[2]}/login`
    const user = store.getters['login/currentUser']
    if (store.getters['login/isLoggedIn']) {
      if (to.fullPath.includes('dicomvix') && user.cd_medico > 0 && user.sn_clinico) {
        next()
      } else if (to.fullPath.includes('solicitante') && user.cd_medico > 0) {
        next()
      } else if (to.fullPath.includes('clinux') && user.cd_funcionario > 0) {
        next()
      } else if (to.fullPath.includes('pesquisa') && user.cd_funcionario > 0) {
        next()
      } else if (to.fullPath.includes('entrega') && user.cd_funcionario > 0) {
        next()
      } else if (to.fullPath.includes('portal') && user.cd_paciente > 0) {
        next()
      } else if (to.fullPath.includes('otrs') && user.cd_cliente > 0) {
        next()
      } else if (to.fullPath.includes('painel') && user.cd_funcionario > 0) {
        next()
      } else if (to.fullPath.includes('anamnese') && user.cd_funcionario > 0) {
        next()
      } else {
        router.push(urlLogin)
      }
    } else {
      router.push(urlLogin)
    }
  } else {
    next()
  }
})

export default router
